import React from "react";
import { Search } from "../../components/search/search";
export const SearchProduct = () => {
  return (
    <div className="my-5 py-5">
      <Search />
    </div>
  );
};
